/**
 * GAPI and address search -> gampi module
 */
export const GET_PLACE_GOOGLE = 'GET_PLACE_GOOGLE';
export const GET_PLACE_API = 'GET_PLACE_API';
export const SET_PLACE_GOOGLE = 'SET_PLACE_GOOGLE';
export const SET_PLACE_API = 'SET_PLACE_API';
